import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'circle-caret-up', 'CircleCaretUp', [["path",{"d":"M12 9l4 4h-8l4 -4"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}]]);